<template>
  <div class="sw-modal">
    <div v-click-outside="cancel" class="sw-modal-content edit-template">
      <div class="row sw-modal-heading">
        <div class="col">
          <h4>
            <i class="fas fa-file-alt"></i>
            Submit for WhatsApp approval
          </h4>
        </div>
      </div>
      <div class="sw-modal-body template" v-if="template">
        <div class="row">
          <div class="col">
            <p>This template will be submitted to WhatsApp for approval. Approval by WhatsApp ranges from 5 minutes to 24 hours.</p>
          </div>
        </div>
        <ValidationObserver ref="whatsAppTemplateForm" tag="form" v-on:submit.prevent="submitTemplate()">
          <ul>
            <li class="row">
              <div class="col-12">
                <label for="category">Choose a Category</label>
                <div id="category">
                  <div class="edit-template__category">
                    <input type="radio" v-model="template.category" v-bind:value="'utility'">
                    <span>
                      <strong>Utility</strong> (recommended)<br/>
                      To communicate with customers about a booking.
                    </span>
                  </div>
                  <div class="edit-template__category">
                    <input type="radio" v-model="template.category" v-bind:value="'marketing'" disabled>
                    <span>
                      <strong>Marketing</strong> (not at present)<br/>
                      For promotions or offers, or updates not related to a booking.<br/>
                      Any conversation that does not qualify as utility is a marketing conversation.
                    </span>
                  </div>

                </div>
              </div>
            </li>

<!--            <li class="row">-->
<!--              <div class="col-12">-->
<!--                <label for="recategorize">Allow WhatsApp to recategorize this template</label>-->
<!--                <div id="recategorize" class="edit-template__category">-->
<!--                  <input type="checkbox" v-model="template.recategorize"/>-->
<!--                  WhatsApp may review this template and come to the conclusion that the template is miscategorized.-->
<!--                  Not allowing WhatsApp to recategorize the template may result in template rejection. A new template-->
<!--                  can be submitted with the appropriate category if rejected.-->
<!--                </div>-->
<!--              </div>-->
<!--            </li>-->

          </ul>

          <div v-show="waiting">
            <Spinner/>
          </div>

          <div v-show="!waiting" class="col-12">
            <div v-if="error">
              <div class="col-12 alert alert-danger" role="alert">
                {{error}}
              </div>
              <button v-on:click.prevent="cancel" class="btn btn-secondary">Close</button>
            </div>
            <div v-else-if="success">
              <div class="col-12 alert alert-success" role="alert">
                {{success}}
              </div>
              <button v-on:click.prevent="$root.$emit('finished-editing-template')" class="btn btn-secondary">Done</button>
            </div>
            <div v-else class="row justify-content-center">
              <div class="col-6">
                <button v-on:click.stop="cancel" class="btn btn-secondary">Cancel</button>
              </div>
              <div class="col-6">
                <button class="btn btn-primary"><span class="d-none d-md-inline">Submit for </span><span class="d-inline d-md-none">Get </span>Approval</button>
              </div>
            </div>
          </div>
        </ValidationObserver>
      </div>
    </div>
  </div>
</template>

<script>
    import { store } from '../../store.js'
    import { ValidationObserver, /*extend*/ } from 'vee-validate'

    import Spinner from '../../components/Spinner.vue'

    import {datesMixin} from "../../mixins/DatesMixin"
    import {languagesMixin} from '../../mixins/LanguagesMixin'
    
    export default {
        name: 'SubmitTemplate',
        components: {
            Spinner, ValidationObserver
            // Draggable, Spinner, QuestionPreview, Markdown
        },
        mixins: [datesMixin, languagesMixin],
        props: {
            template: Object
        },
        data: function () {
            return {
                contentInput: null,
                submitForApproval: true,
                waiting: false,
                error: null,
                success: null
            }
        },
        computed: {
            viewingTemplate: function() {
                if (this.template && typeof this.template.reference !== 'undefined') {
                    return true;
                }
                return false;
            },
            remainingCharacters: function() {
                console.log(this.template.content.length);
                return 950 - this.template.content.length;
            },
        },
        methods: {
            submitTemplate: async function() {
                const success = await this.$refs.whatsAppTemplateForm.validate();
                if (!success) {
                    console.log("Validation failed");
                    return
                }

                console.log("Submitting template");
                this.waiting = true;
                this.error = null;

                const body = {
                    category: this.template.category,
                    recategorize: this.template.recategorize
                };

                this.$http.post('/guest-management/v1/establishments/' + store.currentEstablishmentReference + '/templates/' + this.template.reference + '/submit', body
                ).then(response => {
                    console.log("Template added. Response: " + response);
                    this.waiting = false;
                    this.success = "Template submitted for approval";
                    setTimeout(() => {
                        this.$root.$emit('finished-submitting-template', response.data);
                    }, 2000)
                }).catch(error => {
                    this.waiting = false
                    if (error.response) {
                        this.error = "Error: " + error.response.data.message
                    } else {
                        this.error = "Sorry, we can't seem to reach our servers! Please try again"
                    }
                })

            },
            cancel: function() {
                console.log("Cancelling");
                this.$root.$emit('finished-submitting-template');
            }
        },
        mounted: async function() {
            this.template.category = 'utility';
            this.template.recategorize = true;
        }
    }

</script>

<style lang="scss" scoped>
  @import "../../styles/components/modal";
  @import "../../styles/components/question_answer";
  @import "../../styles/components/edit_template";


  // Todo: ::v-deep Deprecated in Vue 3
  .template__preview ::v-deep .template__preview-variable {
    display: inline-block;
    border: 1px dotted $blue-dark;
    background-color: $blue-light;
    padding: 0 3px;
    color: $black;
  }
</style>